import { Routes } from '@angular/router';

/**
 * Three top-level routes: landing (pick "new" vs "check status"), the new
 * complaint wizard, and the check-status page. All three are lazy-loaded so
 * the initial paint stays lightweight.
 */
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./features/new-complaint/new-complaint-wizard.component').then(
        (m) => m.NewComplaintWizardComponent
      ),
  },
  {
    path: 'status',
    loadComponent: () =>
      import('./features/check-status/check-status.component').then(
        (m) => m.CheckStatusComponent
      ),
  },
  { path: '**', redirectTo: '' },
];
